import { openDB } from 'idb';

const DB_NAME = 'MyShoppingWeb';
const DB_VERSION = 1;
const TOKEN_STORE_NAME = 'MyShoppingWebDB';

export const GetTokenFromIndexedDB = async (key: string) => {
  try {
    const dbExists = await checkIfDBExists(DB_NAME);

    if (dbExists) {
      return await retrieveTokenFromDatabase(key);
    } else {
      // Handle case where database doesn't exist
      return null;
    }
  } catch (error) {
    console.error('Error retrieving token from IndexedDB:', error);
    return null;
  }
};

async function checkIfDBExists(dbName: string): Promise<boolean> {
  const dbNames = await window.indexedDB.databases();
  return dbNames.some((db) => db.name === dbName);
}

async function retrieveTokenFromDatabase(key: string) {
  try {
    const db = await openDB(DB_NAME, DB_VERSION);
    const tx = db.transaction(TOKEN_STORE_NAME, 'readonly');
    const store = tx.objectStore(TOKEN_STORE_NAME);
    const token = await store.get(key);
    await tx.done;
    db.close();
    return token;
  } catch (error) {
    console.error('Error retrieving token from database:', error);
    return null;
  }
}
